import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';

import { useHistory } from '@spazious/dollhouse-store';
import { styled } from '@spazious/dollhouse-theme';
import { Flex, FlexProps } from '@spazious/dollhouse-uikit';

export interface HistoryTimelineViewportProps extends FlexProps {
  maxVisibleItems?: number;
}
export const HistoryTimelineViewport = styled(
  forwardRef<HTMLDivElement, HistoryTimelineViewportProps>((props, ref) => {
    const viewportRef = useRef<HTMLDivElement>(null);
    const { head } = useHistory();

    useImperativeHandle(ref, () => viewportRef.current as HTMLDivElement);

    useEffect(() => {
      const element = document.querySelector(`[data-history-hash="${head.hash}"]`);
      element?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'start' });
    }, [head.hash]);

    return <Flex ref={viewportRef} {...props} />;
  })
)`
  ${({ maxVisibleItems = 6 }) => `
  --max-visible-items: ${maxVisibleItems};
  @media screen and (max-width: 768px) {
    --max-visible-items: ${Math.ceil(maxVisibleItems / 2)};
  }
  `};

  justify-content: center;
  font-size: 25px;
  max-width: calc(
    var(--max-visible-items) * 48px + (var(--max-visible-items) - 1) * var(--spacing-gap)
  );
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
`;
